import useMode from '../stores/mode';

function Back() {
    const mode = useMode();

    return (
        <button
            className="Back"
            onClick={() => {
                mode.set('ar');
            }}
        >
            Close
        </button>
    );
}

export default Back;
